/* istanbul ignore file */
var colors = {
    actionBground: '#FFFAEB',
    actionFlag: '#CAA416',
    activityTableGrey: '#f9f9f9',
    aliceBlue: '#f0f3f5',
    black: '#000000',
    charcoal: '#4C4C4C',
    claimBground: '#FCF4F3',
    claimFlag: '#9E2A1F',
    completedBground: '#F0F6EF',
    completedFlag: '#2B5D1D',
    cyanBlue: '#34657F',
    darkGreen: '#3b8128',
    darkYellow: '#8A700F',
    denimBlue: '#34657f',
    dimGrey: '#656565',
    doveGrey: '#666666',
    error: '#C63527',
    green: '#67AC53',
    greenText: '#2B5C1D',
    grey: '#808080',
    greyNinetyEight: '#fafafa',
    hoverBlue: '#f0f3f5',
    info: '#0072AD',
    lightBlack: '#333333',
    lighterGrey: '#dddddd',
    lightestGrey: '#f6f6f6',
    lightGreen: '#f0f6ef',
    lightGrey: '#e0e0e0',
    lightYellow: '#FFFAEB',
    limeGreen: '#E7F6E3',
    maroon: '#aa0f00',
    mediumGreen: '#9fc294',
    mineShaft: '#232323',
    olive: '#8A6C00',
    reviewBground: '#FCF4F3',
    reviewFlag: '#9E2A1F',
    rockBlue: '#9ab2bf',
    safariBlack: '#000001',
    shadow: '#000001a',
    skyBlue: '#EBF7FF',
    steelGrey: '#3b3c43',
    success: '#3E8529',
    teal: '#6EA6C4',
    turquoiseLightest: '#F1F8F8',
    warning: '#F0D675',
    white: '#ffffff',
    yellow: '#FBC600'
};
var statusColors = {
    greenBground: '#E7F6E3',
    greenBorder: '#67AC53',
    greenFlag: '#3E8529',
    blueBground: '#EBF7FF',
    blueBorder: '#6EA6C4',
    blueFlag: '#34657F',
    redBground: '#9E2A1F',
    redBorder: '#CC3F33',
    redFlag: '#9E2A20',
    yellowBground: '#FFFAEB',
    yellowBorder: '#EBC847',
    yellowFlag: '#CAA416'
};
var opacities = {
    darkBlack: 'rgba(0, 0 , 0 ,0.87)',
    lightBlack: 'rgba(0, 0, 0, 0.1)',
    lightGrey: 'rgba(101, 101, 101, 0.1)',
    shadowGrey: 'rgba(0,0,0,0.2)',
    lightSmoke: 'rgba(0, 0, 0, 0.04)',
    darkSmoke: 'rgba(0, 0, 0, 0.08)',
    lightBlue: 'rgba(53, 101, 127, 1)'
};
var pallete = {
    pieChart: {
        inProgress: '#FBC600'
    },
    body: {
        background: '#F6F6F6',
        text: '#333333'
    },
    button: {
        primary: {
            text: '#FFFFFF',
            hover: '#244759'
        },
        secondary: {
            hover: '#EBF0F2'
        },
        text: '#34657F',
        background: '#34657F'
    },
    field: {
        icon: '#34657F',
        focus: '#34657F',
        label: '#34657F'
    },
    progressStepBar: {
        fill: '#34657F',
        hover: '#D6E0E5',
        label: '#34657F'
    },
    progressBar: {
        complete: '#3e8529',
        error: '#c63527',
        inProgress: '#FBC600',
        background: '#e9eaeb'
    },
    checkbox: {
        background: '#34657F',
        font: '#FFFFFF'
    },
    tooltip: {
        borderColor: '#ffffff',
        backgroundColor: '#ffffff',
        color: '#000000'
    },
    binart: {
        background: '#34657f',
        disableBackground: '#ebf0f2',
        disableBorderColor: '#9eb5c2'
    },
    systemNavigation: {
        background: '#FFFFFF',
        borderColor: '#E0E0E0'
    },
    navigation: {
        activeTabText: '#34657F',
        activeTabBorder: '#34657F'
    },
    datepicker: {
        dueDate: '#CDE5E7',
        selectedDate: '#34657F',
        selectedDateText: '#FFFFFF',
        legend: {
            selectedDate: {
                fill: '#34657F',
                border: '#34657F',
                text: '#ffffff'
            },
            dueDate: {
                fill: '#ffffff',
                border: '#000000',
                text: '#000000'
            },
            lateFeeDate: {
                fill: '#757575',
                border: '#757575',
                text: '#ffffff'
            }
        }
    },
    accordion: {
        borderColor: '#e2e2e2',
        headerBackgroundColor: '#ffffff',
        activeHeaderBackgroundColor: '#f5f5f5'
    },
    chip: {
        hover: '#ffe5ad',
        text: '#34657F'
    },
    switch: {
        background: '#34657F'
    },
    radio: {
        border: '#34657F',
        background: '#34657F'
    },
    header: {
        background: '#FFFFFF',
        text: '',
        border: '#E0E0E0'
    },
    footer: {
        background: '#3B3C43',
        text: '#FFFFFF',
        link: '',
        border: ''
    },
    heroBackground: '',
    modal: { background: '#ffffff', headerBackground: '#f6f6f6' },
    formBackground: '',
    headerDivider: '',
    footerDivider: '',
    contrastingText: '',
    languageSelector: '#333333',
    link: '#34657F',
    icon: '#34657F',
    focus: '#34657F',
    hoverBackground: '#EEF6F7'
};
var theme = {
    colors: colors,
    opacities: opacities,
    pallete: pallete,
    statusColors: statusColors
};
export default theme;
//# sourceMappingURL=theme.js.map